import * as React from "react";

import { Button } from "@replo/design-system/components/button/Button";
import { Minus, Plus } from "lucide-react";

type QuantityControlProps = {
  value: number;
  onIncrement: () => void;
  onDecrement: () => void;
  label: React.ReactNode;
  minValue?: number;
  maxValue?: number;
};

const QuantityControl: React.FC<QuantityControlProps> = ({
  value,
  onIncrement,
  onDecrement,
  label,
  minValue = 0,
  maxValue,
}) => {
  return (
    <div className="flex items-center border border-border bg-white rounded-md px-2 text-default h-8">
      <div className="flex w-full items-center justify-center gap-1">
        <Button
          icon
          variant="tertiary"
          size="sm"
          onClick={onDecrement}
          disabled={value <= minValue}
        >
          <Minus />
        </Button>

        <span className="text-center text-xs font-body">{label}</span>

        <Button
          icon
          variant="tertiary"
          size="sm"
          onClick={onIncrement}
          disabled={value >= (maxValue ?? Number.POSITIVE_INFINITY)}
        >
          <Plus />
        </Button>
      </div>
    </div>
  );
};

export default QuantityControl;
